export default __webpack_public_path__ + "static/media/plogo.9d2b7bb0.png";